import { render, staticRenderFns } from "./b-ticket-private-lounge-details.vue?vue&type=template&id=9c8651a8&scoped=true"
import script from "./b-ticket-private-lounge-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./b-ticket-private-lounge-details.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./b-ticket-private-lounge-details.vue?vue&type=style&index=0&id=9c8651a8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8651a8",
  null
  
)

export default component.exports